<template>
  <label :class="{'disabled': disabled}" class="i-checks i-checks-lg text-lg block m-b-md">
    <input :name="name" :disabled="disabled" @change="e => $emit('input', e.target.value)" :checked="value === model" type="radio" :value="val">
    <i></i>
    {{ label }}
  </label>
</template>

<script>
import InputMixin from "./InputMixin"
export default {
  name: "MRadio",
  mixins: [InputMixin],
  props: {
    name: {
      type: String,
      required: true
    },
    val: {
      required: true
    }
  }
}
</script>
